import { ref } from 'vue';
import { useModal } from '@/ui/concerns/modals/useModal';
import { router } from '@/ui/routes';
import type { Course } from '@/entities/trainings';

export function useStartCourseModal() {
  const [isStartModalOpen, openStartModal, closeStartModal] = useModal(false);
  const courseToStart = ref<Course | null>(null);

  const openStartCourse = (course: Course) => {
    courseToStart.value = course;
    openStartModal();
  };

  const confirmStartCourse = () => {
    if (!courseToStart.value) {
      return;
    }

    router.push({ name: 'courseTake', params: { id: courseToStart.value.id.toString() } });
    closeStartModal();
  };

  return {
    isStartModalOpen,
    openStartModal,
    closeStartModal,
    courseToStart,
    openStartCourse,
    confirmStartCourse,
  };
}
